export const swh = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 15,
  inputPaddingInline: 25,

  inputHeight: 35,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 15,
  inputFontFamily: '"Muli", sans-serif',
  inputColor: "#0B1F44",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 700,

  inputBorderColor: "#FFFFFF",
  inputBorderWidth: 1,
  inputBorderRadius: 6,

  inputHoverColor: "#0B1F44",
  inputHoverBorderColor: "#FFFFFF",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 15,
  selectPaddingInline: 25,

  selectHeight: 35,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 15,
  selectFontFamily: '"Muli", sans-serif',
  selectColor: "#0B1F44",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 700,

  selectBorderColor: "#FFFFFF",
  selectBorderWidth: 1,
  selectBorderRadius: 6,

  selectHoverColor: "#0B1F44",
  selectHoverBorderColor: "#FFFFFF",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 15,
  textAreaPaddingInline: 25,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 15,
  textAreaFontFamily: '"Muli", sans-serif',
  textAreaColor: "#0B1F44",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 700,

  textAreaBorderColor: "#FFFFFF",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 6,

  textAreaHoverColor: "#0B1F44",
  textAreaHoverBorderColor: "#FFFFFF",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#0B1F44",
  placeholderFontFamily: '"Muli", sans-serif',
  placeholderFontSize: 15,
  placeholderFontWeight: 700,
  placeholderHoverColor: "#0B1F44",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 15,
  fieldLabelColor: "#FFFFFF",
  fieldLabelFontWeight: 700,
  fieldLabelColorAsterisk: "#FFFFFF",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Muli", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#FFFFFF",
  descriptionFontSize: 12,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Muli", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 6,
  checkboxUncheckedBorderColor: "#FFFFFF",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBorderColor: "#FFFFFF",
  checkboxCheckedColor: "#0B1F44",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Muli", sans-serif',
  checkboxLabelFontSize: 15,
  checkboxLabelFontWeight: 700,
  checkboxLabelColor: "#FFFFFF",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#FFFFFF",
  radioUncheckedBackgroundColor: "#FFFFFF",
  radioCheckedBackgroundColor: "#0B1F44",
  radioCheckedBorderColor: "#FFFFFF",

  radioAlignment: "none",

  radioLabelFontFamily: '"Muli", sans-serif',
  radioLabelFontSize: 15,
  radioLabelFontWeight: 700,
  radioLabelColor: "#FFFFFF",

  // **********************************
  // submit button

  submitMarginTop: 38,
  submitFontSize: 16,
  submitFontFamily: "'Muli', sans-serif",
  submitWidth: 100,
  submitWidthUnits: "%",
  submitHeight: 45,
  submitBorderRadius: 12,
  submitBorderWidth: 1,
  submitBackground: "#CD4945",
  submitColor: "#FFFFFF",
  submitBorderColor: "#CD4945",
  submitBackgroundHover: "#CD4945",
  submitBorderColorHover: "#CD4945",
  submitColorHover: "#FFFFFF",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  